import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Box, Typography } from '@mui/material';

const CatalogRestricted = ({ title, description, message }) => {
    const renderMessage = () => {
        if (!message) return null;
        if (typeof message === 'string') {
            return <Box color="text.secondary" sx={{ maxWidth: '640px', '& p': { m: 0 } }} dangerouslySetInnerHTML={{ __html: message }} />;
        }
        return (
            <Typography variant="body1" component="div" color="text.secondary" sx={{ maxWidth: '640px' }}>
                {message}
            </Typography>
        );
    };

    return (
        <>
            <Helmet>
                <title>{title} - DevX Infra</title>
            </Helmet>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: '500px',
                    gap: '12px',
                    px: 2,
                    textAlign: 'center',
                }}
            >
                {description ? (
                    <Typography variant="h3" color="text.secondary" sx={{ maxWidth: '640px', fontWeight: 'bold' }}>
                        {description}
                    </Typography>
                ) : null}
                {renderMessage()}
            </Box>
        </>
    );
};

CatalogRestricted.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    message: PropTypes.node,
};

CatalogRestricted.defaultProps = {
    title: 'Catalog Unavailable',
    description: '',
    message: '',
};

export default CatalogRestricted;
